// lib/subject-guard.ts

export const HUB_SUBJECTS = [
  "physics-tuition",
  "chemistry-tuition",
  "biology-tuition",
  "maths-tuition",
  "ip-physics-tuition",
  "ip-maths-tuition",
  "ip-chemistry-tuition",
  "ip-biology-tuition",
  "ip-lower-secondary-maths-tuition",
  "ip-lower-secondary-science-tuition",
  "ip-upper-secondary-maths-tuition",
  "ip-upper-secondary-physics-tuition",
  "ip-upper-secondary-chemistry-tuition",
  "ip-upper-secondary-biology-tuition",
  "secondary-physics-tuition",
  "o-level-physics-tuition",
  "o-level-chemistry-tuition",
  "o-level-biology-tuition",
  "a-level-physics-tuition",
  "a-level-maths-tuition",
  "a-level-chemistry-tuition",
  "a-level-biology-tuition",
  "ip-combined-sciences-lower-sec-notes",
  "ip-maths-lower-sec-notes",
  "ip-emaths-upper-sec-notes",
  "ip-amaths-upper-sec-notes",
  "ip-physics-upper-sec-notes",
  "ip-chemistry-upper-sec-notes",
  "ip-biology-upper-sec-notes",
  "sec-g3-mathematics-notes",
  "sec-g3-additional-mathematics-notes",
  "sec-g3-physics-notes",
  "sec-g3-chemistry-notes",
  "sec-g3-biology-notes",
  "sec-g3-science-physics-chemistry-notes",
  "sec-g3-science-physics-biology-notes",
  "sec-g3-science-chemistry-biology-notes",
  "h2-physics-notes",
  "h2-maths-notes",
  "h2-chemistry-notes",
  "h2-biology-notes",
  "h2-physics-experiments",
  "h2-chemistry-experiments",
  "h2-biology-experiments",
  "ip-science-practicals",
  "ip-lower-secondary-science-practicals",
  "ip-physics-practicals",
  "ip-chemistry-practicals",
  "ip-biology-practicals",
  "o-level-physics-experiments",
  "o-level-chemistry-experiments",
  "o-level-biology-experiments",
  "o-level-combined-science",
  "o-level-combined-science-practicals",
  "o-level-science-physics-practical",
  "o-level-science-chemistry-practical",
  "o-level-science-biology-practical",
  "igcse-physics-notes",
  "igcse-chemistry-notes",
  "igcse-biology-notes",
  "igcse-mathematics-notes",
  "igcse-additional-mathematics-notes",
  "igcse-combined-science-notes",
  "igcse-combined-science-experiments",
  "igcse-coordinated-sciences-notes",
  "igcse-coordinated-sciences-experiments",
  "igcse-physics-experiments",
  "igcse-chemistry-experiments",
  "igcse-biology-experiments",
  "igcse-cie-singapore",
  "pearson-igcse-mathematics-a-notes",
  "pearson-igcse-further-pure-mathematics-notes",
  "pearson-igcse-biology-notes",
  "pearson-igcse-biology-practicals",
  "pearson-igcse-chemistry-notes",
  "pearson-igcse-chemistry-practicals",
  "pearson-igcse-physics-notes",
  "pearson-igcse-physics-practicals",
  "pearson-igcse-science-double-award-notes",
  "pearson-igcse-science-double-award-practicals",
  "pearson-edexcel-international-gcse",
  "cambridge-international-a-level",
  "cambridge-international-a-level-mathematics-notes",
  "cambridge-international-a-level-further-mathematics-notes",
  "cambridge-international-a-level-biology-notes",
  "cambridge-international-a-level-biology-practicals",
  "cambridge-international-a-level-chemistry-notes",
  "cambridge-international-a-level-chemistry-practicals",
  "cambridge-international-a-level-physics-notes",
  "cambridge-international-a-level-physics-practicals",
  "cambridge-international-as-environmental-management-notes",
  "cambridge-international-as-environmental-management-investigations",
  "cambridge-international-a-level-marine-science-notes",
  "cambridge-international-a-level-marine-science-practicals",
  "pearson-edexcel-international-advanced-level",
  "pearson-ial-mathematics-notes",
  "pearson-ial-further-mathematics-notes",
  "pearson-ial-pure-mathematics-notes",
  "pearson-ial-biology-notes",
  "pearson-ial-biology-practicals",
  "pearson-ial-chemistry-notes",
  "pearson-ial-chemistry-practicals",
  "pearson-ial-physics-notes",
  "pearson-ial-physics-practicals",
  "igcse-international-mathematics-notes",
  "igcse-statistics-notes",
  "igcse-environmental-management-notes",
  "igcse-environmental-management-fieldwork",
  "igcse-marine-science-notes",
  "igcse-marine-science-practicals",
  "pearson-igcse-mathematics-b-notes",
  "pearson-igcse-science-single-award-notes",
  "pearson-igcse-science-single-award-practicals",
  "pearson-igcse-human-biology-notes",
  "pearson-igcse-human-biology-practicals",
  "scholarships",
  "bursaries",
  "japan-scholarships",
  "korea-scholarships",
  "general",
  "science-lab-guide",
] as const;

export type KnownSubject = (typeof HUB_SUBJECTS)[number];

const KNOWN_SUBJECTS = new Set<KnownSubject>(HUB_SUBJECTS);

const SUBJECT_ALIASES: Record<string, KnownSubject> = {
  "ip-physics": "ip-physics-tuition",
  "ip-maths": "ip-maths-tuition",
  "ip-chemistry": "ip-chemistry-tuition",
  "ip-biology": "ip-biology-tuition",
  "ip-lower-secondary-maths": "ip-lower-secondary-maths-tuition",
  "ip-lower-secondary-science": "ip-lower-secondary-science-tuition",
  "ip-upper-secondary-maths": "ip-upper-secondary-maths-tuition",
  "ip-upper-secondary-physics": "ip-upper-secondary-physics-tuition",
  "ip-upper-secondary-chemistry": "ip-upper-secondary-chemistry-tuition",
  "ip-upper-secondary-biology": "ip-upper-secondary-biology-tuition",
  "secondary-physics": "secondary-physics-tuition",
  "o-level-physics": "o-level-physics-tuition",
  "a-level-physics": "a-level-physics-tuition",
  "a-level-maths": "a-level-maths-tuition",
  "a-level-chemistry": "a-level-chemistry-tuition",
  "a-level-biology": "a-level-biology-tuition",
  "jc-physics-tuition": "a-level-physics-tuition",
  "jc-maths-tuition": "a-level-maths-tuition",
  "jc-chemistry-tuition": "a-level-chemistry-tuition",
  "jc-biology-tuition": "a-level-biology-tuition",
  "o-level-chemistry": "o-level-chemistry-tuition",
  "o-level-biology": "o-level-biology-tuition",
  "h2-chemistry": "h2-chemistry-notes",
  "h2-biology": "h2-biology-notes",
  "h2-maths": "h2-maths-notes",
  "olevel-physics-experiments": "o-level-physics-experiments",
  "olevel-chemistry-experiments": "o-level-chemistry-experiments",
  "olevel-biology-experiments": "o-level-biology-experiments",
  "o-level-combined-science-practical": "o-level-combined-science-practicals",
  "combined-science": "o-level-combined-science",
  "o-level-science-physics": "o-level-science-physics-practical",
  "o-level-science-chemistry": "o-level-science-chemistry-practical",
  "o-level-science-biology": "o-level-science-biology-practical",
  "igcse-cie": "igcse-cie-singapore",
};

/** Returns the canonical hub subject if recognised, else null. */
export function toKnownSubject(
  maybe: string | null | undefined
): KnownSubject | null {
  if (!maybe) return null;
  const canonical = SUBJECT_ALIASES[maybe] ?? maybe;
  return KNOWN_SUBJECTS.has(canonical as KnownSubject)
    ? (canonical as KnownSubject)
    : null;
}
